export const getInitials = (nameString: string) => {
    const regexChar = /\D\w+/;
    return nameString
        .trim() // remove trailing spaces
        .split(' ') // splits on spaces
        .filter((word) => word.length > 0) // strip out double spaces
        .filter((word) => regexChar.test(word)) // strip out special characters
        .map((word) => word.substring(0, 1).toUpperCase()); // take first letter from each word and put into array
};
